type TestimonialContentProps = {
  name: string;
  title: string;
  body: string;
};

export const testimonials: TestimonialContentProps[] = [
  {
    name: 'Gina',
    title: 'We love you, Zola!!',
    body: '"We set up a free wedding website that is gorgeous and looks so professional. Our family members could not believe it, and somehow think that we made it ourselves?! There are so many features that have been absolutely life-saving with wedding planning. Zola keeps track of our RSVPs, and gifts. Absolutely love Zola."',
  },
  {
    name: 'Deb',
    title: 'Easy and simple',
    body: '"I have enjoyed the experience of creating my invitations on the Zola site, as well as designing my website and creating my registry. It has been easy and simple to work with, and does so much more of what I needed than other wedding sites."',
  },
];
